export const BRAND = {
  company: {
    full: process.env.NEXT_PUBLIC_BRAND_COMPANY_NAME || 'MoveHQ US',
    short: process.env.NEXT_PUBLIC_BRAND_COMPANY_SHORT || 'MHQ',
  },
  contact: {
    customerCarePhone: process.env.NEXT_PUBLIC_BRAND_CUSTOMER_CARE_PHONE || '(555) 555-5555',
    customerCareEmail: process.env.NEXT_PUBLIC_BRAND_CUSTOMER_CARE_EMAIL || 'no-reply@movehq.us',
  },
  urls: {
    // TODO: confirm "Fact Sheet" resource link
    factSheet: process.env.NEXT_PUBLIC_BRAND_FACT_SHEET_URL || 'https://demo.movehq.us/customers',
    privacyPolicy: process.env.NEXT_PUBLIC_BRAND_PRIVACY_POLICY_URL || 'https://www.movehq.com/privacy-policy',
    termsOfService: process.env.NEXT_PUBLIC_BRAND_TOS_URL || 'https://www.movehq.com/msa',
    // TODO: confirm document ID for MCO transfer info
    mcoTransferInfo: process.env.NEXT_PUBLIC_BRAND_MCO_TRANSFER_URL || 'https://demo.movehq.us/document/6096',
  },
} as const;

export type BrandConfig = typeof BRAND;
